export default "__VITE_ASSET__Deb_ocCV__"